import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, unref as _unref } from "vue"

const _hoisted_1 = ["role", "aria-modal"]
const _hoisted_2 = { class: "spv__panel" }
const _hoisted_3 = {
  key: 0,
  class: "spv__head"
}
const _hoisted_4 = {
  key: 1,
  class: "spv__embed-hint"
}
const _hoisted_5 = { class: "spv__top" }
const _hoisted_6 = { class: "spv__gallery" }
const _hoisted_7 = { class: "spv__main" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "spv__main-empty"
}
const _hoisted_10 = {
  key: 0,
  class: "spv__thumbs"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "spv__buy" }
const _hoisted_14 = { class: "spv__store" }
const _hoisted_15 = { class: "spv__cat" }
const _hoisted_16 = { class: "spv__name" }
const _hoisted_17 = { class: "spv__summary" }
const _hoisted_18 = { class: "spv__price" }
const _hoisted_19 = { class: "spv__unit-tag" }
const _hoisted_20 = {
  key: 0,
  class: "spv__photo"
}
const _hoisted_21 = { class: "spv__photo" }
const _hoisted_22 = { class: "spv__info" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "spv__info" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "spv__options" }
const _hoisted_29 = {
  class: "spv__options-select",
  disabled: "",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 0,
  class: "spv__options-list"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "spv__options-empty"
}
const _hoisted_34 = { class: "spv__info" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = {
  key: 0,
  class: "spv__tags"
}
const _hoisted_39 = {
  key: 1,
  class: "spv__empty-inline"
}
const _hoisted_40 = {
  key: 0,
  class: "spv__spec"
}
const _hoisted_41 = {
  key: 1,
  class: "spv__empty"
}
const _hoisted_42 = {
  key: 0,
  class: "spv__desc"
}
const _hoisted_43 = {
  key: 1,
  class: "spv__blocks"
}
const _hoisted_44 = {
  key: 0,
  class: "spv__block-heading"
}
const _hoisted_45 = {
  key: 1,
  class: "spv__block-text"
}
const _hoisted_46 = {
  key: 2,
  class: "spv__block-notice"
}
const _hoisted_47 = {
  key: 3,
  class: "spv__block-image"
}
const _hoisted_48 = ["src", "alt"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 2,
  class: "spv__empty"
}

import { computed, onMounted, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import MallOrderPackMark from '@/components/mall/MallOrderPackMark.vue'
import type { ProductPreviewZone } from '@/constants/productEditor'
import { MALL_FULFILLMENT_LIMIT } from '@/constants/mall'
import { formatPrice, type MallProduct } from '@/constants/mallProducts'
import { calcMallUnitPrice } from '@/utils/mallPricing'
import { scrollWhenReady } from '@/utils/scrollIntoContainer'
import { useSameDayCutoffText } from '@/composables/useContentSnippets'
import {
  formatMinOrderLabel,
  formatShippingChargeLabel,
  isOrderPack,
  formatStockCount,
  imageShowsCaption,
  sellUnitNoun,
  sellUnitSummary,
  storefrontOffer,
} from '@/utils/mallSell'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerProductPreview',
  props: {
    product: {},
    activeZone: { default: '' },
    embedded: { type: Boolean, default: false }
  },
  emits: ["close", "edit-zone"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const activeIndex = ref(0)
const scrollEl = ref<HTMLElement | null>(null)

const images = computed(() => {
  const list = props.product.images?.length ? props.product.images : [props.product.image]
  return list.filter(Boolean)
})

const activeImage = computed(() => images.value[activeIndex.value] ?? images.value[0] ?? '')

watch(images, () => {
  activeIndex.value = 0
})

const blocks = computed(() => props.product.blocks ?? [])

const offer = computed(() => storefrontOffer(props.product))
const priced = computed(() =>
  calcMallUnitPrice({
    listPrice: props.product.listPrice,
    salePrice: props.product.price,
    orgDiscountPct: 0,
  }),
)

const shippingText = computed(() => formatShippingChargeLabel(props.product))
const isGroupBuy = computed(() => props.product.mallKind === 'SALE')
const cartonPieces = computed(() => Math.max(1, props.product.packQty || props.product.orderStep || 1))
const sellNoun = computed(() => sellUnitNoun(props.product.sellUnit))
const imageCaption = computed(() => imageShowsCaption(props.product))
const sellSummary = computed(() => sellUnitSummary(props.product))
const minOrderText = computed(() => `${formatMinOrderLabel(props.product.minOrder, props.product.sellUnit)}부터`)
const { sameDayCutoffText, loadSameDayCutoffSnippet } = useSameDayCutoffText(
  () => props.product.storeCutoff,
)

onMounted(() => {
  void loadSameDayCutoffSnippet()
})

const optionChoices = computed(() => {
  const list = (props.product.options ?? []).filter(
    (option) => option.use !== false && String(option.name || '').trim(),
  )
  const productStock = Math.max(0, Number(props.product.stock) || 0)
  if (!list.length) {
    return [
      {
        key: 'default',
        name: props.product.unit || '기본',
        label: props.product.unit || '기본',
        extra: 0,
        stock: productStock,
      },
    ]
  }

  const grouped = new Map<string, typeof list>()
  list.forEach((option) => {
    const name = option.group?.trim() || '구성'
    const rows = grouped.get(name) ?? []
    rows.push(option)
    grouped.set(name, rows)
  })
  const groups = [...grouped.values()]
  const tracks = list.some((option) => (Number(option.stock) || 0) > 0)
  const stockOf = (stock: number) => (tracks ? Math.max(0, stock) : productStock)
  const labelOf = (name: string, extra: number) =>
    name + (extra ? ` (${extra > 0 ? '+' : ''}${formatPrice(extra)}원)` : '')

  if (groups.length === 1) {
    return groups[0].map((option, index) => {
      const extra = Number(option.extra) || 0
      return {
        key: `${option.group}-${option.name}-${index}`,
        name: option.name.trim(),
        label: labelOf(option.name.trim(), extra),
        extra,
        stock: stockOf(Number(option.stock) || 0),
      }
    })
  }

  let combos = groups[0].map((option) => ({
    parts: [option.name.trim()],
    extra: Number(option.extra) || 0,
    stock: Number(option.stock) || 0,
  }))
  groups.slice(1).forEach((group) => {
    const next: typeof combos = []
    combos.forEach((combo) => {
      group.forEach((option) => {
        next.push({
          parts: [...combo.parts, option.name.trim()],
          extra: combo.extra + (Number(option.extra) || 0),
          stock: Math.min(combo.stock, Number(option.stock) || 0),
        })
      })
    })
    combos = next
  })
  return combos.map((combo, index) => {
    const name = combo.parts.join(' / ')
    return {
      key: `${name}-${index}`,
      name,
      label: labelOf(name, combo.extra),
      extra: combo.extra,
      stock: stockOf(combo.stock),
    }
  })
})

function isOn(zone: ProductPreviewZone): boolean {
  return props.activeZone === zone
}

function emitEdit(zone: ProductPreviewZone) {
  emit('edit-zone', zone)
}

watch(
  () => props.activeZone,
  async (zone) => {
    if (!zone) return
    await scrollWhenReady(
      () => {
        const root = scrollEl.value
        if (!root) return null
        return root.querySelector(`[data-zone="${zone}"]`) as HTMLElement | null
      },
      {
        behavior: 'auto',
        block: 'center',
        offsetTop: props.embedded ? 130 : 12,
        offsetBottom: 24,
      },
      500,
    )
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spv", { 'spv--embedded': __props.embedded }]),
    role: __props.embedded ? 'region' : 'dialog',
    "aria-modal": __props.embedded ? undefined : true,
    "aria-label": "상품 상세 미리보기",
    onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (!__props.embedded && emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      (!__props.embedded)
        ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
            _cache[25] || (_cache[25] = _createElementVNode("h2", null, [
              _createTextVNode(" 상세 미리보기 "),
              _createElementVNode("em", null, "구매 기관에게 이렇게 보입니다 · 영역을 누르면 입력칸으로 이동합니다")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "spv__close",
              "aria-label": "닫기",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, [
              _createVNode(AppIcon, {
                icon: "mdi-close",
                size: 20
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, " 아래 영역을 누르면 왼쪽 입력칸으로 이동합니다. 입력칸을 누르면 여기가 강조됩니다. ")),
      _createElementVNode("div", {
        ref_key: "scrollEl",
        ref: scrollEl,
        class: "spv__scroll"
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["spv__zone", { 'is-on': isOn('gallery') || isOn('badge') }]),
            "data-zone": "gallery",
            role: "button",
            tabindex: "0",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emitEdit('gallery'))),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (emitEdit('gallery')), ["prevent"]), ["enter"]))
          }, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "spv__zone-label" }, "이미지 · 배지", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (activeImage.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: activeImage.value,
                      alt: __props.product.name
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(AppIcon, {
                        icon: "mdi-image-outline",
                        size: 34
                      }),
                      _cache[26] || (_cache[26] = _createElementVNode("span", null, "이미지를 등록하면 여기에 보입니다", -1))
                    ])),
                (__props.product.badge)
                  ? (_openBlock(), _createElementBlock("em", {
                      key: 2,
                      class: _normalizeClass(["spv__badge", { 'is-on': isOn('badge') }]),
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emitEdit('badge')), ["stop"]))
                    }, _toDisplayString(__props.product.badge), 3))
                  : _createCommentVNode("", true)
              ]),
              (images.value.length > 1)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: image }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass({ 'is-active': index === activeIndex.value }),
                          onClick: _withModifiers(($event: any) => (activeIndex.value = index), ["stop"])
                        }, [
                          _createElementVNode("img", {
                            src: image,
                            alt: `${__props.product.name} 이미지 ${index + 1}`
                          }, null, 8, _hoisted_12)
                        ], 10, _hoisted_11)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 34),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('cate') }]),
              "data-zone": "cate",
              role: "button",
              tabindex: "0",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emitEdit('cate'))),
              onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (emitEdit('cate')), ["prevent"]), ["enter"]))
            }, [
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "spv__zone-label" }, "분류", -1)),
              _createElementVNode("p", _hoisted_14, [
                _createVNode(AppIcon, {
                  icon: "mdi-storefront-outline",
                  size: 15
                }),
                _createTextVNode(" " + _toDisplayString(__props.product.storeName || '내 스토어') + " ", 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(__props.product.category), 1)
              ])
            ], 34),
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('name') }]),
              "data-zone": "name",
              role: "button",
              tabindex: "0",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (emitEdit('name'))),
              onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (emitEdit('name')), ["prevent"]), ["enter"]))
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "spv__zone-label" }, "상품명 · 단위", -1)),
              _createElementVNode("h3", _hoisted_16, _toDisplayString(__props.product.name || '상품명 없음'), 1)
            ], 34),
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('summary') }]),
              "data-zone": "summary",
              role: "button",
              tabindex: "0",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (emitEdit('summary'))),
              onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (emitEdit('summary')), ["prevent"]), ["enter"]))
            }, [
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "spv__zone-label" }, "한 줄 요약", -1)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(__props.product.summary || '요약을 입력하면 여기에 보입니다.'), 1)
            ], 34),
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('price') }]),
              "data-zone": "price",
              role: "button",
              tabindex: "0",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (emitEdit('price'))),
              onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (emitEdit('price')), ["prevent"]), ["enter"]))
            }, [
              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "spv__zone-label" }, "가격", -1)),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(isGroupBuy.value ? priced.value.unitPrice * cartonPieces.value : offer.value.price)), 1),
                _cache[31] || (_cache[31] = _createElementVNode("span", null, "원", -1)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(isGroupBuy.value ? '/카톤' : offer.value.name || (sellNoun.value === '박스' ? '/박스' : '')), 1)
              ]),
              (isGroupBuy.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(cartonPieces.value) + "개 묶음 · 1개당 " + _toDisplayString(_unref(formatPrice)(priced.value.unitPrice)) + "원", 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_21, _toDisplayString(imageCaption.value), 1),
              _createElementVNode("dl", _hoisted_22, [
                _createElementVNode("div", null, [
                  _cache[32] || (_cache[32] = _createElementVNode("dt", null, "판매", -1)),
                  _createElementVNode("dd", null, _toDisplayString(isGroupBuy.value ? `${cartonPieces.value}개 묶음` : sellSummary.value), 1)
                ]),
                (__props.product.unit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _cache[33] || (_cache[33] = _createElementVNode("dt", null, "구성", -1)),
                      _createElementVNode("dd", null, _toDisplayString(__props.product.unit), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 34),
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('stock') }]),
              "data-zone": "stock",
              role: "button",
              tabindex: "0",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (emitEdit('stock'))),
              onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (emitEdit('stock')), ["prevent"]), ["enter"]))
            }, [
              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "spv__zone-label" }, "재고 · 주문", -1)),
              _createElementVNode("dl", _hoisted_24, [
                (isGroupBuy.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[35] || (_cache[35] = [
                      _createElementVNode("dt", null, "주문", -1),
                      _createElementVNode("dd", null, "최소 1카톤", -1)
                    ]))]))
                  : (_unref(isOrderPack)(__props.product.orderStep))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _cache[36] || (_cache[36] = _createElementVNode("dt", null, "주문", -1)),
                        _createElementVNode("dd", null, [
                          _createVNode(MallOrderPackMark, {
                            size: "inline",
                            "order-step": __props.product.orderStep || 1,
                            "sell-unit": __props.product.sellUnit
                          }, null, 8, ["order-step", "sell-unit"])
                        ])
                      ]))
                    : (__props.product.minOrder > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _cache[37] || (_cache[37] = _createElementVNode("dt", null, "최소 주문", -1)),
                          _createElementVNode("dd", null, _toDisplayString(minOrderText.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _cache[38] || (_cache[38] = _createElementVNode("dt", null, "재고", -1)),
                  _createElementVNode("dd", {
                    class: _normalizeClass({ 'is-warn': (__props.product.stock ?? 0) <= 0 })
                  }, _toDisplayString((__props.product.stock ?? 0) > 0
                        ? _unref(formatStockCount)(__props.product.stock ?? 0, __props.product.sellUnit)
                        : '재고 없음 (품절로 노출)'), 3)
                ])
              ])
            ], 34),
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('options') }]),
              "data-zone": "options",
              role: "button",
              tabindex: "0",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (emitEdit('options'))),
              onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (emitEdit('options')), ["prevent"]), ["enter"]))
            }, [
              _cache[41] || (_cache[41] = _createElementVNode("span", { class: "spv__zone-label" }, "옵션 선택", -1)),
              _createElementVNode("div", _hoisted_28, [
                _cache[40] || (_cache[40] = _createElementVNode("p", { class: "spv__options-label" }, [
                  _createTextVNode("옵션 선택 "),
                  _createElementVNode("em", null, "(필수)")
                ], -1)),
                _createElementVNode("select", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionChoices.value, (choice) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: choice.key,
                      value: choice.key
                    }, _toDisplayString(choice.label), 9, _hoisted_30))
                  }), 128))
                ]),
                (optionChoices.value.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionChoices.value, (choice) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `row-${choice.key}`
                        }, [
                          _createElementVNode("strong", null, _toDisplayString(choice.name), 1),
                          (choice.extra)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(choice.extra > 0 ? '+' : '') + _toDisplayString(_unref(formatPrice)(choice.extra)) + "원 ", 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("em", {
                            class: _normalizeClass({ 'is-warn': choice.stock <= 0 })
                          }, _toDisplayString(choice.stock > 0 ? `재고 ${_unref(formatPrice)(choice.stock)}` : '품절'), 3)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_33, "옵션을 만들면 상세에서 선택창으로 보입니다."))
              ])
            ], 34),
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('ship') }]),
              "data-zone": "ship",
              role: "button",
              tabindex: "0",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (emitEdit('ship'))),
              onKeydown: _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (emitEdit('ship')), ["prevent"]), ["enter"]))
            }, [
              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "spv__zone-label" }, "배송", -1)),
              _createElementVNode("dl", _hoisted_34, [
                _createElementVNode("div", null, [
                  _cache[42] || (_cache[42] = _createElementVNode("dt", null, "배송비", -1)),
                  _createElementVNode("dd", null, _toDisplayString(shippingText.value), 1)
                ]),
                (__props.product.leadTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _cache[43] || (_cache[43] = _createElementVNode("dt", null, "출고", -1)),
                      _createElementVNode("dd", null, _toDisplayString(__props.product.leadTime), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _cache[44] || (_cache[44] = _createElementVNode("dt", null, "수령", -1)),
                  _createElementVNode("dd", null, _toDisplayString(_unref(MALL_FULFILLMENT_LIMIT)), 1)
                ]),
                (_unref(sameDayCutoffText))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _cache[45] || (_cache[45] = _createElementVNode("dt", null, "당일 출고", -1)),
                      _createElementVNode("dd", null, _toDisplayString(_unref(sameDayCutoffText)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.product.origin || __props.product.maker)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _cache[46] || (_cache[46] = _createElementVNode("dt", null, "원산지 · 제조", -1)),
                      _createElementVNode("dd", null, _toDisplayString([__props.product.origin, __props.product.maker].filter(Boolean).join(' · ')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 34),
            _createElementVNode("div", {
              class: _normalizeClass(["spv__zone", { 'is-on': isOn('tags') }]),
              "data-zone": "tags",
              role: "button",
              tabindex: "0",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (emitEdit('tags'))),
              onKeydown: _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (emitEdit('tags')), ["prevent"]), ["enter"]))
            }, [
              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "spv__zone-label" }, "해시태그", -1)),
              (__props.product.tags.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.tags, (tag) => {
                      return (_openBlock(), _createElementBlock("li", { key: tag }, "#" + _toDisplayString(tag), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_39, "태그를 넣으면 여기에 보입니다."))
            ], 34),
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "spv__cta" }, [
              _createElementVNode("span", { class: "spv__cta-cart" }, "장바구니"),
              _createElementVNode("span", { class: "spv__cta-buy" }, "바로구매")
            ], -1)),
            _cache[50] || (_cache[50] = _createElementVNode("p", { class: "spv__cta-note" }, "구매 버튼은 미리보기에서 동작하지 않습니다.", -1))
          ])
        ]),
        _createElementVNode("section", {
          class: _normalizeClass(["spv__section spv__zone", { 'is-on': isOn('specs') }]),
          "data-zone": "specs",
          role: "button",
          tabindex: "0",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (emitEdit('specs'))),
          onKeydown: _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (emitEdit('specs')), ["prevent"]), ["enter"]))
        }, [
          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "spv__zone-label" }, "요약정보", -1)),
          _cache[52] || (_cache[52] = _createElementVNode("h4", null, "상품 정보", -1)),
          (__props.product.highlights.length)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.highlights, (spec) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: spec.label
                  }, [
                    _createElementVNode("dt", null, _toDisplayString(spec.label), 1),
                    _createElementVNode("dd", null, _toDisplayString(spec.value), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_41, "요약정보(스펙)를 입력하면 표로 보입니다."))
        ], 34),
        _createElementVNode("section", {
          class: _normalizeClass(["spv__section spv__zone", { 'is-on': isOn('detail') || isOn('desc') }]),
          "data-zone": "detail",
          role: "button",
          tabindex: "0",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (emitEdit('detail'))),
          onKeydown: _cache[23] || (_cache[23] = _withKeys(_withModifiers(($event: any) => (emitEdit('detail')), ["prevent"]), ["enter"]))
        }, [
          _cache[53] || (_cache[53] = _createElementVNode("span", { class: "spv__zone-label" }, "상품 소개 · 상세", -1)),
          _cache[54] || (_cache[54] = _createElementVNode("h4", null, "상세 설명", -1)),
          (__props.product.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(__props.product.description), 1))
            : _createCommentVNode("", true),
          (blocks.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blocks.value, (block, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (block.type === 'HEADING')
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_44, _toDisplayString(block.text), 1))
                      : (block.type === 'TEXT')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(block.text), 1))
                        : (block.type === 'NOTICE')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                              _createVNode(AppIcon, {
                                icon: "mdi-information-outline",
                                size: 16
                              }),
                              _createTextVNode(" " + _toDisplayString(block.text), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("figure", _hoisted_47, [
                              _createElementVNode("img", {
                                src: block.imageUrl,
                                alt: block.alt || __props.product.name
                              }, null, 8, _hoisted_48),
                              (block.alt)
                                ? (_openBlock(), _createElementBlock("figcaption", _hoisted_49, _toDisplayString(block.alt), 1))
                                : _createCommentVNode("", true)
                            ]))
                  ], 64))
                }), 128))
              ]))
            : (!__props.product.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, " 상세 페이지 블록을 넣으면 이 자리에 순서대로 보입니다. "))
              : _createCommentVNode("", true)
        ], 34)
      ], 512)
    ])
  ], 10, _hoisted_1))
}
}

})